import React, { useEffect, useState } from "react";
import { Dropdown, Menu, Row } from "antd";
import {
  FlagSpain,
  FlagUnitedStates,
  FlagFrance,
  FlagPortuguese,
  FlagRussia,
  FlagSweden,
  FlagChina,
} from "./Icon";
import { LANGS, LANG_KEY } from "../shared/constants";
import { CaretDownOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { CustomMenu } from "./Components";
import { useMedia } from "react-use";

const langIcons: { [key: string]: any } = {
  en: FlagUnitedStates,
  es: FlagSpain,
  fr: FlagFrance,
  sc: FlagSweden,
  pg: FlagPortuguese,
  rs: FlagRussia,
  cn: FlagChina,
};

const LangSwitcher = () => {
  const [lang, setLang] = useState<string | React.ReactText>("en");
  const CurrentLangFlag = langIcons[lang];
  const isTabletOrMobile = useMedia("(max-width: 1224px)");
  const { t, i18n } = useTranslation();

  const langs: { [key: string]: string } = {
    en: t("English"),
    es: t("Spanish"),
    fr: t("France"),
    sc: t("Sweden"),
    pg: t("Portuguese"),
    cn: t("Chino"),
    rs: t("Russia"),
  };

  useEffect(() => {
    const lang = localStorage.getItem(LANG_KEY);

    if (lang) {
      setLang(lang);
      i18n.changeLanguage(lang);
    }
  }, [i18n]);

  const handleOnClick = (info: any) => {
    const lang = info.key;

    setLang(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem(LANG_KEY, lang);
  };

  const menu = (
    <CustomMenu style={{ minWidth: 130 }} onClick={handleOnClick}>
      {LANGS.map((_lang) => {
        const FlagIcon = langIcons[_lang];

        if (lang !== _lang) {
          return (
            <Menu.Item key={_lang}>
              <Row justify="start" align="middle">
                <FlagIcon
                  style={{
                    fontSize: 24,
                    marginRight: 8,
                  }}
                />
                {langs[_lang]}
              </Row>
            </Menu.Item>
          );
        }

        return null;
      })}
    </CustomMenu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <Row justify="start" align="middle" style={{ cursor: "pointer" }}>
        <CurrentLangFlag
          style={{
            fontSize: 24,
            marginRight: 8,
          }}
        />
        {!isTabletOrMobile && <span>{langs[lang]}</span>}
        <CaretDownOutlined style={{ marginLeft: 8 }} />
      </Row>
    </Dropdown>
  );
};

export default LangSwitcher;
